<template>
    <div class="maxContainer subscriptionPlan"> 
      <!-- <img src="../../../../static/fxView/images/platform.svg" alt="" class="platfromThumb"> -->
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="mainTitle text-center my-3">
          <h3 class="mb-4">  {{ $t('TraderToolSubscription') }}</h3>
        </div> 
        <div class="row d-flex justify-content-center">
			<div class="col-4 pr-md-0" v-for="list in subPlanList.records" v-if="subPlanList.totalRecords > 0 && parseInt(list.id) == 6">
				<div class="glimpseBox mb-3">
					<h4 class="border-bottom pb-3 mb-3 d-flex align-items-center justify-content-between">
						<span>{{list.plan_name}}</span>
						<router-link :to="{name: 'fxView.subscription_service_plan' , query: { 'id':list.id}}" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="!serviceFunction(list.id)" class="badge badge-pill badge-success"> {{ $t('activate') }}</router-link>
					</h4>
					<p class="mb-3">{{$t('unmatchedTradingExperience')}}</p>
					<router-link :to="{name: 'fxView.subscription_service_plan' , query: { 'id':list.id}}" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip">
						{{$t('requestAccess')}}
					</router-link>
				</div>
			</div>
        </div> 
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'Subscription-Tool',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : '1'
			}
		},
		methods:{
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {},
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetSubPlanList(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_SUB_PLAN_LIST] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/subscription_tool.vue